module.exports = __webpack_public_path__ + "static/twitterBanner-7ba6a763bfa25bc196695b434bd5e929.jpg";